import Box from '@mui/material/Box';
import Select, { SelectChangeEvent } from 'atoms/Select';
import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useStore } from 'stores/store';
import {
  getTimeZoneCode,
  getUserTimeZone,
  USER_TIME_ZONE_LOCAL_STORAGE_KEY
} from 'utils/dateUtils';

const OPTIONS = [
  {
    value: getUserTimeZone(),
    name: `${getUserTimeZone()} (${getTimeZoneCode(getUserTimeZone())})`
  },
  { value: 'Israel', name: `Israel (${getTimeZoneCode('Israel')})` },
  { value: 'America/New_York', name: `America/New_York (${getTimeZoneCode('America/New_York')})` },
  {
    value: 'America/Los_Angeles',
    name: `America/Los_Angeles (${getTimeZoneCode('America/Los_Angeles')})`
  },
  { value: 'America/Chicago', name: `America/Chicago (${getTimeZoneCode('America/Chicago')})` }
];

const optionsUnique = OPTIONS.filter(
  ({ value }, index, self) =>
    index === self.findIndex((t) => getTimeZoneCode(t.value) === getTimeZoneCode(value))
);

const TimeZoneSelect = ({ className }: { className?: string }) => {
  const { UIStore } = useStore();
  const [value, setValue] = useState('');

  useEffect(() => {
    const storedTimeZone = localStorage.getItem(USER_TIME_ZONE_LOCAL_STORAGE_KEY);

    if (storedTimeZone && !!moment.tz.zone(storedTimeZone)) {
      setValue(storedTimeZone);
      UIStore.setUserTimeZone(storedTimeZone);
      return;
    }
    setValue(getUserTimeZone());
    UIStore.setUserTimeZone(getUserTimeZone());
    localStorage.setItem(USER_TIME_ZONE_LOCAL_STORAGE_KEY, getUserTimeZone());
  }, [UIStore]);

  const saveTimeZone = (e: SelectChangeEvent<string>) => {
    setValue(e.target.value);
    UIStore.setUserTimeZone(e.target.value);
    localStorage.setItem(USER_TIME_ZONE_LOCAL_STORAGE_KEY, e.target.value);
  };

  return (
    <Box className={className} sx={{ minWidth: '265px' }}>
      <Select
        sx={{ width: '100%' }}
        labelId={`select-label`}
        value={value}
        onChange={saveTimeZone}
        size="small"
        options={optionsUnique}
      />
    </Box>
  );
};

export default observer(TimeZoneSelect);
